import React from "react";
import { Box, Divider, Paper, Typography } from "@mui/material";
import type { DeveloperGuide } from "../../types";

interface DeveloperGuideViewerProps {
  guide: DeveloperGuide;
}

const DeveloperGuideViewer: React.FC<DeveloperGuideViewerProps> = ({ guide }) => {
  const sections = [...(guide.sections ?? [])].sort(
    (a, b) => a.sortOrder - b.sortOrder,
  );

  return (
    <Box>
      {guide.description?.trim() && (
        <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
          {guide.description}
        </Typography>
      )}

      {sections.map((section, index) => (
        <Paper key={section.id} variant="outlined" sx={{ p: 2, mb: 2 }}>
          <Typography variant="h6" sx={{ mb: 1 }}>
            {section.title}
          </Typography>
          {section.instructions?.trim() && (
            <Typography
              variant="body2"
              sx={{ whiteSpace: "pre-wrap", mb: 2 }}
            >
              {section.instructions}
            </Typography>
          )}
          {section.codeSamples?.map((sample) => (
            <Box key={sample.id} sx={{ mb: 2 }}>
              <Typography variant="caption" color="text.secondary">
                {sample.label || "Example"} ({sample.language})
              </Typography>
              <Box
                component="pre"
                sx={{
                  bgcolor: "grey.900",
                  color: "grey.100",
                  p: 2,
                  borderRadius: 1,
                  overflow: "auto",
                  fontSize: "0.85rem",
                  mt: 0.5,
                }}
              >
                <code>{sample.code}</code>
              </Box>
            </Box>
          ))}
          {index < sections.length - 1 && <Divider sx={{ mt: 2 }} />}
        </Paper>
      ))}
    </Box>
  );
};

export default DeveloperGuideViewer;
